export default "__VITE_ASSET__d19ed327__"